import Link from "next/link";
import { FaGithub, FaLinkedinIn } from "react-icons/fa";
import { SiUpwork } from "react-icons/si";
import { ReactElement } from "react";

interface SocialItem {
  icon: ReactElement;
  path: string;
  label: string;
}

const Socials: SocialItem[] = [
  {
    icon: <FaGithub aria-hidden="true" focusable="false" />,
    path: "https://github.com/pkalani1999",
    label: "Parth Kalani on GitHub",
  },
  {
    icon: <FaLinkedinIn aria-hidden="true" focusable="false" />,
    path: "https://www.linkedin.com/in/parth-kalani-414706148/",
    label: "Parth Kalani on LinkedIn",
  },
  {
    icon: <SiUpwork aria-hidden="true" focusable="false" />,
    path: "https://www.upwork.com/freelancers/parthk24",
    label: "Parth Kalani on Upwork",
  },
];

interface SocialProps {
  containerStyles?: string;
  iconStyles?: string;
}

const Social = ({ containerStyles, iconStyles }: SocialProps) => {
  return (
    <div className={containerStyles}>
      {Socials.map((item) => (
        <Link
          key={item.path}
          href={item.path}
          className={iconStyles}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={item.label}
          title={item.label}
        >
          {item.icon}
        </Link>
      ))}
    </div>
  );
};

export default Social;
